import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b5aa0ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0b5aa0ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_webpack@5.107.2__lodash@4.18.1_react-dom@16.2.0_rea_78eced9430f46a1a0ce5e8103c760d82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5aa0ac",
  null
  
)

export default component.exports